<template>
  <div class="body-container">
    <div class="body-box-top">
      <el-carousel :interval="5000" height="418px" class="school-img">
        <el-carousel-item v-for="(item, index) in schoolImg" :key="index">
          <img :src="item.advUrl" :style="{width:'1250px',height:'420px'}" @click="skipJobPages(item.linkUrl)" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 场次列表 -->
    <div class="body-box-cclb">
      <div class="cclb-top">
        <div></div>
        <div class="title">场次列表</div>
        <div class="serch-div">
          <el-input class="serch-input" v-model="parmas.name" prefix-icon="el-icon-search" placeholder="请输入内容" clearable>
            <el-button slot="append" raround @click="getHotPostList()">搜索</el-button>
          </el-input>
        </div>
      </div>
      <div class="cclb-bottom">
        <div class="cclb-item" v-for="(item, index) in hotPostList" :key="index">
          <div class="message-one" @click="openCollegesMessage(item.id)">
            <div class="cclb-rigth">
              <img :src="item.schoolBadge" alt="scaleToFill" :style="{ width: '56px', height: '56px' }" />
            </div>
            <div class="cclb-center">
              <!-- 高校名称 -->
              <div>{{ item.name }}</div>
              <div class="cclb-center-size">
                <!-- 高校地址 -->
                <span class="shuxian">{{ item.address }}</span>
                <!-- 院校类型 -->
                <span v-for="schoolCategory in schoolCategoryList" :key="schoolCategory.id">
                  <span v-if="schoolCategory.id == item.schoolCategory" class="shuxian">{{
                    schoolCategory.name
                  }}</span>
                </span>
                <!-- 院校特色 -->
                <span v-for="featureId in item.schoolFeature.split(',')" :key="featureId.id">
                  <span v-for="schoolFeature in schoolFeatureList" :key="schoolFeature.id">
                    <span v-if="schoolFeature.id === featureId">
                      {{ schoolFeature.name }}
                    </span>
                  </span>
                </span>
              </div>
            </div>
            <div class="cclb-left">共{{ item.mutualCount }}场</div>
          </div>
          <!-- 下面框框 -->
          <div>
            <div class="message-two" @click="skipJobPages(item.doubleChannelId)" v-if="item.mutualCount > 0">
              <div class="message-two-left">
                <div class="message-two-name">{{ item.schoolDoubleChannels[0].mutualName }}</div>
                <div class="message-two-time">
                  <div class="message-two-time-left">
                    <span v-if="item.schoolDoubleChannels.length > 0 && item.schoolDoubleChannels[0].mutualParticipation == 1">线上参会</span>
                    <span v-if="item.schoolDoubleChannels.length > 0 && item.schoolDoubleChannels[0].mutualParticipation == 2">线下参会</span>
                  </div>
                  <div class="message-two-time-left-1">
                    <span v-if="item.schoolDoubleChannels[0].presell == 2">场次预售</span>
                  </div>
                  <div class="message-two-time-rigth" v-if="item.schoolDoubleChannels[0].mutualParticipation == 1 || item.schoolDoubleChannels[0].mutualParticipation == 2">
                    {{ formatDateTime(item.schoolProcessList[0].handleTime) }}
                    {{ formatDateTime(item.schoolProcessList[1].handleTime, false) }}
                  </div>
                  <div v-if="item.schoolDoubleChannels[0].presell == 2" class="message-two-time-rigth-1">
                    {{ formatDateTime(item.schoolProcessList[0].handleTime) }}
                    {{ formatDateTime(item.schoolProcessList[1].handleTime, false) }}
                  </div>
                </div>
              </div>
              <div class="message-two-rigth"></div>
            </div>
            <div class="message-two-2" v-else>暂无数据</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 企业推荐 -->
    <div class="body-box-qytj">
      <div class="qytj-top">
        <div></div>
        <div class="title">企业推荐</div>
      </div>
    </div>
    <div class="bottom-banner">
      <div v-for="item in schoolEnterpriseImgList" :key="item.id" class="bottom-banner-img">
        <img :src="item.advUrl" :style="{width:'1200px',height:'96px'}" class="banner-img-bottom" />
      </div>
    </div>
    <!-- 高校信息弹出框 -->
    <el-dialog :visible.sync="messageDialogVisible" width="800px">
      <div class="colleges-message-top">
        共{{ this.schoolDoubleChannelList.length }}场线下双选会
      </div>
      <div class="dialog-one" ref="dialogForm">
        <div class="dialog-one-left">
          <div>
            <img :src="dialogForm.schoolBadge" alt="scaleToFill" class="img-hover" :style="{ width: '80px', height: '80px' }" />
          </div>
          <div class="dialog-one-name">{{ dialogForm.name }}</div>
          <div class="message-address">
            <span class="shuxian">{{ dialogForm.address }}</span>
            <span v-if="dialogForm.schoolCategory">
              <span v-for="schoolCategory in schoolCategoryList" :key="schoolCategory.id">
                <span v-if="schoolCategory.id == dialogForm.schoolCategory">{{
                  schoolCategory.name
                }}</span>
              </span>
            </span>
          </div>
          <div class="schoolFeature-center">
            <span v-for="featureId in dialogForm.schoolFeature" :key="featureId.id">
              <span v-for="schoolFeature in schoolFeatureList" :key="schoolFeature.id">
                <span v-if="schoolFeature.id === featureId" class="message-schoolFeature">
                  {{ schoolFeature.name }}
                </span>
              </span>
            </span>
          </div>
        </div>
        <div class="dialog-one-right">
          <div>
            <div v-if="this.schoolDoubleChannelList.length > 0">
              <div class="colleges-message-right-bg" v-for="item in schoolDoubleChannelList" :key="item.id">
                <div @click="skipJobPages(item.id)">
                  <div class="message-bg-name">{{ item.mutualName }}</div>
                  <div class="message-right-top">
                    <div class="message-right-top-left">
                      <span v-if="item.mutualParticipation ==1">线上参会</span>
                      <span v-if="item.mutualParticipation ==2">线下参会</span>
                    </div>
                    <div class="message-right-top-left-1">
                      <span v-if="item.presell == 2">场次预售</span>
                    </div>
                    <div class="message-right-top-right">
                      {{ formatDateTime(item.schoolProcessList[0].handleTime) }}
                      {{ formatDateTime(item.schoolProcessList[1].handleTime, false) }}
                    </div>
                  </div>
                  <div class="message-right-top-01">
                    <img src="../../assets/icon/location-icon.png" alt="" class="message-right-top-img" :style="{ width: '15px', height: '15px' }" />
                    {{ item.conferenceAddress }}
                  </div>
                  <div class="message-bg-name-rigth"></div>

                </div>
              </div>
            </div>
            <div class="colleges-message-right-bg-1" v-else>暂无数据</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      schoolImg: [],
      title: "",
      hotPostList: [],
      schoolCategoryList: [],
      schoolFeatureList: [],
      parmas: {
        pageNum: 1,
        pageSize: 9,
      },
      messageDialogVisible: false,
      dialogForm: {},
      schoolDoubleChannelList: [],
      schoolEnterpriseImgList: [],
      startTime: null,
      endTime: null,
    };
  },
  created() {
    this.getSchoolImg();
    this.getHotPostList();
    this.getSchoolCategory();
    this.getSchoolFeature();
    this.getSchoolEnterpriseImg();
  },
  methods: {
    // 轮播图
    getSchoolImg() {
      let parmas = {
        pageNum: 1,
        pageSize: 6,
      };
      this.$api.universities.getSchoolCarouselImg(parmas).then((response) => {
        this.schoolImg = response.rows;
      });
    },
    // 企业推荐图片
    getSchoolEnterpriseImg() {
      let parmas = {
        pageNum: 1,
        pageSize: 5,
      };
      this.$api.universities
        .getSchoolEnterpriseImgList(parmas)
        .then((response) => {
          this.schoolEnterpriseImgList = response.rows;
        });
    },
    formatDateTime(dateString, showDate = true) {
      const date = new Date(dateString);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      const hours = ("0" + date.getHours()).slice(-2);
      const minutes = ("0" + date.getMinutes()).slice(-2);
      const seconds = ("0" + date.getSeconds()).slice(-2);
      if (showDate) {
        const year = date.getFullYear();
        return `${month}月${day}日 ${hours}:${minutes}:${seconds} - `;
      } else {
        return `${month}月${day}日 ${hours}:${minutes}:${seconds}`;
      }
    },
    getHotPostList() {
      let _this = this;
      _this.$api.universities
        .getList(this.parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.hotPostList = res.rows;
          }
        })
        .catch(() => {});
    },
    // 查询院校类别
    getSchoolCategory() {
      this.$api.universities.getSchoolCategory().then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          this.schoolCategoryList.push({
            id: response.data[i].dictValue,
            name: response.data[i].dictLabel,
          });
        }
      });
    },
    // 查询院校特色
    getSchoolFeature() {
      this.$api.universities.getSchoolFeature().then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          this.schoolFeatureList.push({
            id: response.data[i].dictValue,
            name: response.data[i].dictLabel,
          });
        }
      });
    },
    openCollegesMessage(id) {
      const param = {
        id: id,
      };
      this.$api.universities.getCollegesMessage(param).then((response) => {
        this.dialogForm = response.data;
        this.schoolDoubleChannelList = response.data.schoolDoubleChannels;
      });
      this.messageDialogVisible = true;
    },
    // 点击高校信息 传递 ID，跳转到另一个页面
    skipJobPages(id) {
      // 判断是否有ID
      if (!id || id === "") {
        this.$message({
          message: "暂无数据",
          type: "warning",
        });
      } else {
        this.$router.push({ name: "mutualSelection", query: { id: id } });
      }
    },
  },
};
</script>

<style scoped>
.body-container {
  background-color: rgba(164, 171, 189, 0.16);
  width: 100%;
}

.school-img {
  width: 1250px;
  height: 420px;
}

.body-container .body-box-top {
  max-width: 1200px;
  margin: 24px auto;
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
  height: 419px;
}

.body-container .body-box-cclb,
.body-container .body-box-qytj {
  max-width: 1200px;
  margin: 14px auto;
  background-color: #fff;
}

.body-container .body-box-cclb .cclb-top,
.body-container .body-box-qytj .qytj-top {
  height: 54px;
  border-bottom: 2px solid rgb(64, 112, 179);
  display: flex;
  align-items: center;
}

.body-container .body-box-cclb .cclb-top div:nth-child(1),
.body-container .body-box-qytj .qytj-top div:nth-child(1) {
  /* width: 4px; */
  height: 20px;
  background: rgb(64, 112, 179);
  margin: 0px 16px;
}

.body-container .body-box-cclb .cclb-top .title,
.body-container .body-box-qytj .qytj-top .title {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
}

.body-container .body-box-cclb .cclb-bottom,
.body-container .body-box-qytj .qytj-bottom {
  /* padding: 16px; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  background: #f8f9fc;
}

.body-container .body-box-qytj .qytj-bottom .qytj-item {
  padding: 20px;
  width: 24.5%;
  min-height: 160px;
  background: rgb(255, 255, 255);
  box-shadow: 0px 0px 8px rgba(164, 171, 189, 0.48);
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.body-container .body-box-qytj .qytj-bottom .qytj-item .title {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  margin-top: 10px;
}

.bottom-banner {
  max-width: 1200px;
  margin-left: 10.5%;
  margin: 24px auto 0px;
}

/* .bottom-banner-img {
  margin: 15px 0px;
} */
.banner-img-bottom{
  margin-bottom: 25px;
}

.body-container .bottom-fwmk {
  max-width: 1200px;
  margin: 24px auto;
}

.cclb-item {
  width: 33%;
  padding: 15px 16px;
  background: #fff;
  margin-bottom: 8px;
  min-height: 185px;
  cursor: pointer;
  border-radius: 15px;
}

.message-one {
  height: 56px;
}
.message-two {
  border-radius: 15px;
  margin-top: 16px;
  height: 82px;
  background: rgba(88, 124, 247, 0.05);
}

.message-two-2 {
  border-radius: 15px;
  margin-top: 16px;
  height: 82px;
  background: rgba(88, 124, 247, 0.05);
  text-align: center;
  line-height: 82px;
}

.message-two-left {
  float: left;
}

.message-two-rigth {
  float: right;
  width: 22px;
  height: 22px;
  background: #587cf7;
  border-radius: 50%;
  /* line-height: 82px; */
  margin-top: -30px;
  margin-right: -11px;
}
.message-two-rigth::after {
  color: #fff;
  margin: 8px;
  content: ">";
}

.message-two-name {
  width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 40px;
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 40px;
}
.message-two-name:hover {
  color: #587cf7;
}

.cclb-rigth {
  width: 56px;
  height: 56px;
  float: left;
}
.cclb-center {
  float: left;
  padding-left: 15px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.cclb-center:hover {
  color: #587cf7;
}
.cclb-center-size {
  position: relative;
  font-size: 13px;
  color: #7a7f99;
  padding-right: 15px;
  line-height: 40px;
}

.serch-div {
  padding-left: 720px;
}
.serch-input {
  border-radius: 50px;
}
.cclb-left {
  border: 1px solid #587cf7;
  border-radius: 13px;
  float: right;
  width: 60px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  margin-top: 15px;
  color: #587cf7;
}
.cclb-left::after {
  margin-left: 5px;
  content: ">";
}
.colleges-message {
  height: 256px;
  border: 1px solid red;
}
.colleges-message-left {
  width: 240px;
  text-align: center;
  float: left;
  margin-top: 20px;
  padding: 18px 24px;
}
.message-name {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #141933;
  line-height: 22px;
  text-align: center;
  margin: 16px 0 8px;
}
.colleges-message-rigth {
  float: left;
}
el-dialog {
  height: 500px;
}
.message-address {
  text-align: center;
  position: relative;
  font-size: 13px;
  margin-top: 15px;
  color: #7a7f99;
  line-height: 18px;
}
.shuxian::after {
  margin-left: 5px;
  content: "|";
}
.schoolFeature-center {
  margin: 16px auto 0;
}
.message-schoolFeature {
  position: relative;
  font-size: 13px;
  color: #7a7f99;
  padding: 0 10px;
  height: 24px;
  margin-right: 8px;
  border-radius: 12px;
  border: 1px solid #d8dce6;
  /* display: flex; */
  align-items: center;
}
.colleges-message-right {
  float: left;
}
.colleges-message-right-bg {
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* position: relative; */
  padding: 16px 36px 20px 16px;
  width: 437px;
  background: rgba(88, 124, 247, 0.05);
  border-radius: 8px;
  margin-top: 12px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
}
.colleges-message-right-bg-1{
  text-align: center;
  line-height: 230px;
}
.message-right-top-img {
  margin-top: -5px;
}
.message-right-top {
  margin-top: 10px;
}
.message-right-top-01 {
  margin-top: 30px;
  float: left;
  margin-left: -252px;
}
.message-right-top-left {
  float: left;
  width: 60px;
  background: #faaa14;
  position: relative;
  font-size: 13px;
  color: #ffffff;
  text-align: center;
  line-height: 22px;
  border-radius: 8px;
}
.message-right-top-left-1{
  float: left;
  width: 60px;
  background: #587cf7;
  position: relative;
  font-size: 13px;
  color: #ffffff;
  text-align: center;
  line-height: 22px;
  border-radius: 8px;
}
.message-right-top-right {
  float: left;
  margin-left: 10px;
  color: #faaa14;
}
.img-hover {
  /* 过渡配置 */
  transition: all 0.5s ease 0.1s;
}
.img-hover:hover {
  /* 放大1.1倍 */
  transform: scale(1.1);
}
.message-bg-name {
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.message-bg-name:hover {
  color: #587cf7;
}
.colleges-message-top {
  background: #f0f2f6;
  height: 56.8px;
  line-height: 56.8px;
  margin-left: -20px;
  padding-left: 20px;
  margin-top: -60px;
  width: 800px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.message-two-time-left {
  width: 60px;
  background: #faaa14;
  position: relative;
  font-size: 13px;
  color: #ffffff;
  margin-left: 15px;
  text-align: center;
  line-height: 22px;
  border-radius: 8px;
  float: left;
}
.message-two-time-left-1{
  width: 60px;
  background: #587cf7;
  position: relative;
  font-size: 13px;
  color: #ffffff;
  margin-left: 15px;
  text-align: center;
  line-height: 22px;
  border-radius: 8px;
  float: left;
}
.message-two-time-rigth {
  font-size: 13px;
  float: left;
  margin-left: 8px;
  width: 71%;
  color: #faaa14;
}
.message-two-time-rigth-1{
  font-size: 13px;
  float: left;
  margin-left: 8px;
  width: 71%;
  color: #7a7f99;
}
.message-bg-name-rigth {
  float: right;
  width: 22px;
  height: 22px;
  background: #587cf7;
  border-radius: 50%;
  position: fixed;
  margin-left: 408px;
  z-index: 999;
}

.message-bg-name-rigth::after {
  content: ">";
  color: #fff;
  margin-left: 8px;
  margin-bottom: 10px;
}
.dialog-one {
  height: auto;
  overflow-y: auto;
}
.dialog-one-left {
  margin: 25px;
  width: 30%;
  text-align: center;
  float: left;
  border-right: 2px solid #f0f2f6;
}
.dialog-one-right {
  float: left;
  width: 63%;
}
.dialog-one-name {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/recruitment/index.vue